export const NEW_LINE_REGEX = /\n/g;
export const COMMA_REGEX = /,/g;
export const EMPTY_SPACE = " ";

export const BATCH_SIZE = 50;

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light"
}


// WEBPACK FOOTER //
// ./src/components/constants/Constants.js